import clsx from 'clsx';
import Link from 'next/link';

interface Props {
  mode?: 'link';
  label: string;
  href?: string;
  isActive: boolean;
  onClick?: () => void;
}

const SizeFilterItem = (props: Props) => {
  const { mode, label, isActive, href = '#', onClick } = props;

  const className = clsx(
    ' min-h-[36px] border-1 border-solid flex items-center justify-center   px-[5px] text-[13px] lg_text-[15px] lg_hover_border-E7DED5',
    isActive ? 'bg-80583F text-white border-80583F' : 'bg-[#fbf9f7] border-[#eee]',
  );

  if (mode === 'link') {
    return (
      <Link
        href={href}
        className={clsx(className, 'block')}
        onClick={() => {
          onClick?.();
        }}
        data-filter-link='1'
      >
        {label}
      </Link>
    );
  }

  return (
    <div
      onClick={() => {
        onClick?.();
      }}
      className={clsx(className, 'cursor-pointer')}
    >
      {label}
    </div>
  );
};

export default SizeFilterItem;
